import type { ProtocolSource } from '@castoredc/castor_prose';

// The `protocolSource` field of every PROSE request message, built from DSL text.
export const protocolSourceOf = (dslSource: string): ProtocolSource => ({
  representation: { $case: 'sourceCode', value: dslSource },
});
